import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { CenterVertically } from '@sorare/core/src/atoms/layout/CenterVertically';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, LabelM } from '@sorare/core/src/atoms/typography';
import { Countdown } from '@sorare/core/src/components/Countdown';
import { Dialog } from '@sorare/core/src/components/dialog';

const DialogContent = styled(Vertical)`
  padding: var(--double-unit);
`;
const FooterContent = styled.div`
  padding: 0 var(--double-unit) var(--double-unit);
`;

type Props = { date: Date; open: boolean; onClose: () => void };

export const CountdownDialog = ({ date, open, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      hideHeader
      footer={
        <FooterContent>
          <Button fullWidth size="medium" color="quaternary" onClick={onClose}>
            <FormattedMessage defaultMessage="Got it" />
          </Button>
        </FooterContent>
      }
    >
      <CenterVertically>
        <DialogContent gap={2} center>
          <LabelM color="var(--c-nd-600)" className="text-center">
            <FormattedMessage defaultMessage="Hold tight!" />
          </LabelM>
          <Countdown greyOutZeros date={date} />
          <BodyM className="text-center">
            <FormattedMessage
              defaultMessage="You recently levelled up your card.{br}You need to wait some time before doing it again."
              values={{ br: <br /> }}
            />
          </BodyM>
        </DialogContent>
      </CenterVertically>
    </Dialog>
  );
};
